import { chatDesignAIAssistantMethods } from './chatMethods';
import {
  promptStrategistJsonSchema,
  promptStrategistMcpServerDescription,
  promptStrategistMcpToolNameDescription,
  promptStrategistSystemPrompt,
  promptStrategistUserPrompt
} from './promptStrategistMethods';

export * from './types';
export {
  PromptStrategistHttpError,
  PromptStrategistTimeoutError
} from './promptStrategistErrors';

const designAIAssistant = {
  ...chatDesignAIAssistantMethods,
  promptStrategistSystemPrompt,
  promptStrategistUserPrompt,
  promptStrategistJsonSchema,
  promptStrategistMcpServerDescription,
  promptStrategistMcpToolNameDescription
};

export default designAIAssistant;
